import React, { useEffect, useState } from 'react';
import { TableCell, TableRow } from '@mui/material';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import BoxGrid from '@/main/components/shared/boxGrid/boxGrid';
import { getTranslateByKey } from '@/main/services/utils';
import BlackListRegister from './blackListRegister';
import { SupplierCompanyRelationFilterRequest } from '@/main/models/request/supplierCompanyRelationRequest';
import { SupplierCompanyRelationResponse } from '@/main/models/response/supplierCompanyRelationResponse';
import { supplierApi } from '@/main/api';
import { PaginationEnum } from '@/main/services/enum/PaginationEnum';
import * as S from './styles';
import * as StylesShared from '@/main/components/shared/styles';
import KOGPaginationGrid from '../paginationGrid/paginationGrid';
import { SaveSupplierCompanyRelationRequest } from '@/main/models/request';
import { isNil } from 'lodash';
import KogInputTextFilter from '../inputText/inputTextFilter';

interface Props {
  reasonReducer?: any;
  distributionRegionReducer?: any;
  supplierTypeReducer?: any;
  manufacturerReducer?: any;
  watcherCountry?: any;
  guidBodyshop?: any;
  guidInsurer?: any;
  formFilters: any;
  setFormFilters: React.Dispatch<any>;
  blacklistAndMySuppliersDeleteItem: SaveSupplierCompanyRelationRequest[];
  setBlacklistAndMySuppliersDeleteItem: (cb: (data: any[]) => any[]) => void;
}

function BlackListInfo({
  reasonReducer,
  distributionRegionReducer,
  supplierTypeReducer,
  manufacturerReducer,
  watcherCountry,
  guidBodyshop,
  guidInsurer,
  formFilters,
  setFormFilters,
  blacklistAndMySuppliersDeleteItem,
  setBlacklistAndMySuppliersDeleteItem
}: Props) {
  const ID_SCROLLABLE_TARGET =
    'id-scrollable-target-supplierRelations-blacklist';

  const baseFilter: SupplierCompanyRelationFilterRequest = {
    guidBodyshop: guidBodyshop,
    guidInsurer: guidInsurer,
    restricted: true,
    pageIndex: PaginationEnum.PageIndexIntial,
    pageSize: PaginationEnum.PageSize10
  };

  const [open, setOpen] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [dataGrid, setDataGrid] = useState<SupplierCompanyRelationResponse[]>(
    []
  );

  const rowHeaders = [
    getTranslateByKey('information.rfc'),
    getTranslateByKey('information.supplierCompany'),
    <StylesShared.RowHeaderTextCenter>
      {getTranslateByKey('information.refundLimit')}
    </StylesShared.RowHeaderTextCenter>,
    getTranslateByKey('information.reason'),
    getTranslateByKey('information.observation'),
    getTranslateByKey('information.userDateTime'),    
    getTranslateByKey('information.actions')
  ];

  function closeModal() {
    setOpen(false);
  }

  function handleDeleteBlacklistInfo(id: string) {
    setBlacklistAndMySuppliersDeleteItem(prev => {
      return [...prev, { guid: id }];
    });
  }

  function handleChangeFilter(newFilter: string) {
    if(newFilter === formFilters.searchTerm) return;
    const request: SupplierCompanyRelationFilterRequest = {
      ...baseFilter,
      searchTerm: newFilter
    };

    setDataGrid([]);
    setFormFilters(request);
  }

  function loadInitialSearch() {
    setFormFilters(null);
  }

  async function fetchData(request: any) {
    return supplierApi
      .getSupplierRestrictedAndFavorite(request)
      .then(response => response.data);
  }

  useEffect(() => {
    loadInitialSearch();
  }, []);

  useEffect(() => {
    if (formFilters == null) {
      setDataGrid([]);
      setFormFilters(baseFilter);
    }
  }, [formFilters]);

  return (
    <>
      <S.Container id="id-register-container-blackList">
        <S.ContainerTitle>
          <S.HeaderText>
            {getTranslateByKey('information.blackListInfo')}
          </S.HeaderText>
          <SecondaryButton
            style={{
              padding: '.2rem .8rem',
              marginTop: '.6rem'
            }}
            onClick={() => setOpen(true)}
            id="id-register-button-addBlacklist">
            {getTranslateByKey('information.addBlackList')}
          </SecondaryButton>

          <S.AreaFilterGrid>
            <KogInputTextFilter
              id="id-filter-blacklist-search"
              label={getTranslateByKey('information.typeToFilter')}
              onDebounce={handleChangeFilter}
            />
          </S.AreaFilterGrid>
        </S.ContainerTitle>
        <S.ContainerScroll id={ID_SCROLLABLE_TARGET}>
          <KOGPaginationGrid
            idScrollableTarget={ID_SCROLLABLE_TARGET}
            showTitleResults={false}
            totalRecords={totalRecords}
            setTotalRecords={setTotalRecords}
            dataGrid={dataGrid}
            formFilters={formFilters}
            setDataGrid={setDataGrid}
            fetchMore={fetchData}>
            <BoxGrid rowHeaders={rowHeaders}>
              {dataGrid.map(black => (
                <TableRow key={black.guidSupplier}>
                  <TableCell width="10%">{black.registrationNumber}</TableCell>
                  <TableCell width="15%">{black.companyName}</TableCell>
                  <TableCell width="15%" align="center">
                    {!isNil(black.refundLimitFormated)
                      ? black.refundLimitFormated
                      : getTranslateByKey('information.limitNotDefined')}
                  </TableCell>
                  <TableCell width="20%">{black.reason}</TableCell>
                  <TableCell width="20%">{black.observation}</TableCell>
                  <TableCell width="15%">{black.userDateTime}</TableCell>
                  <TableCell width="5%" align="center">
                    {!blacklistAndMySuppliersDeleteItem.some(
                      item => item.guid === black.guid
                    ) && (
                      <S.IconClose
                        onClick={() => handleDeleteBlacklistInfo(black.guid)}
                      />
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </BoxGrid>
          </KOGPaginationGrid>
        </S.ContainerScroll>
      </S.Container>
      <BlackListRegister
        open={open}
        closeModal={closeModal}
        reasonReducer={reasonReducer}
        distributionRegionReducer={distributionRegionReducer}
        supplierTypeReducer={supplierTypeReducer}
        manufacturerReducer={manufacturerReducer}
        watcherCountry={watcherCountry}
        guidBodyshop={guidBodyshop}
        guidInsure={guidInsurer}
        resetGrid={loadInitialSearch}
      />
    </>
  );
}

export default BlackListInfo;
